import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { PaycellService } from '../services/paycell.service';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import { PaymentMethod } from '../services/payment-method.model';
import { CardDeleteAction } from '../card-delete-dialog/card-delete-dialog.action';
import { CardDeleteSuccessAction } from '../card-delete-success-dialog/card-delete-success-dialog.action';
import {
  PaymentProgressChangeAction,
  PaymentProgressStatus
} from '../../components/payment-progress/payment-progress.action';
import NotificationService from '../../common/services/notification/notification.service';
import { OpenCardAddContractAction } from '../card-add-contract-dialog/card-add-contract-dialog.action';
import { PayByPaycellAction } from '../../common/actions/pay-by-paycell.action';
import UtilService from '../../common/services/util.service';
import '../../../assets/img/logo_visa@2x.png';
import '../../../assets/img/card-logo/axess@2x.png';
import '../../../assets/img/card-logo/advantage@2x.png';
import '../../../assets/img/card-logo/advantage@2x.png';
import '../../../assets/img/card-logo/akbank@2x.png';
import '../../../assets/img/card-logo/amex@2x.png';
import '../../../assets/img/card-logo/axess@2x.png';
import '../../../assets/img/card-logo/bonus@2x.png';
import '../../../assets/img/card-logo/cardfinans@2x.png';
import '../../../assets/img/card-logo/dcb@2x.png';
import '../../../assets/img/card-logo/denizbank@2x.png';
import '../../../assets/img/card-logo/garamti@2x.png';
import '../../../assets/img/card-logo/halkbank@2x.png';
import '../../../assets/img/card-logo/ingbank@2x.png';
import '../../../assets/img/card-logo/isbankasi@2x.png';
import '../../../assets/img/card-logo/maestro@2x.png';
import '../../../assets/img/card-logo/mastercard@2x.png';
import '../../../assets/img/card-logo/maximum@2x.png';
import '../../../assets/img/card-logo/odeabank@2x.png';
import '../../../assets/img/card-logo/paraf@2x.png';
import '../../../assets/img/card-logo/qnbfinansbank@2x.png';
import '../../../assets/img/card-logo/teb@2x.png';
import '../../../assets/img/card-logo/turkiyefinans@2x.png';
import '../../../assets/img/card-logo/vakifbank@2x.png';
import '../../../assets/img/card-logo/visa@2x.png';
import '../../../assets/img/card-logo/world@2x.png';
import '../../../assets/img/card-logo/yapikredi@2x.png';
import '../../../assets/img/card-logo/ziraatbankasi@2x.png';
import { OpenDistantSalesAggreementAction } from '../distant-sales-aggreement-dialog/distant-sales-aggreement-dialog.action';
import { DistantSaleAction } from '../../common/actions/distant-sale-action';
import { PreInfoSaleAction } from '../../common/actions/pre-info-action';

/* @ngInject */
export default class PayByCardController {
  public activeCard: PaymentMethod;
  public cards: PaymentMethod[] = [];

  private preInfoAggreement: boolean = false;
  private distantAggreement: boolean = false;

  constructor(
    private $state,
    private $translate,
    private globalSpinner: GlobalSpinnerService,
    private actionDispatcher: ActionDispatcherService,
    private paycellService: PaycellService,
    private notificationService: NotificationService
  ) {
    this.globalSpinner.start();
    this.paycellService
      .getCards()
      .then(cards => {
        this.cards = cards;
        this.activeCard = UtilService.getElements(this.cards, data =>
          this.comparator(data)
        )[0];

        if (angular.isUndefined(this.activeCard)) {
          this.activeCard = this.cards[0];
        }
      })
      .catch((/*error*/) => (this.cards = []))
      .finally(() => this.globalSpinner.stop());
  }

  public $onInit() {
    this.actionDispatcher.dispatch(
      new PaymentProgressChangeAction(PaymentProgressStatus.PAY)
    );
  }

  public onChangeActiveCard(card: PaymentMethod) {
    this.activeCard = card;
  }

  public onAddNewCard() {
    this.actionDispatcher.dispatch(
      new OpenCardAddContractAction(() => this.onAddCard())
    );
  }

  private onAddCard() {
    this.$state.go('addCard');
  }

  public onDeleteCard() {
    this.actionDispatcher.dispatch(
      new CardDeleteAction(
        paymentMethodID => this.onDeleteSuccess(paymentMethodID, this.activeCard.cardId),
        this.activeCard
      )
    );
  }

  private onDeleteSuccess(paymentMethodID: number, cardId: string): any {
    this.actionDispatcher.dispatch(new CardDeleteSuccessAction());
    this.cards = this.cards.filter(
      card => card.paymentMethodID != paymentMethodID || card.cardId != cardId
    );
    this.activeCard = this.cards[0];
  }

  public onConfirm(data: any) {
    this.distantAggreement = data.distant;
    this.preInfoAggreement = data.preInfo;
  }

  public onDistantSale() {
    this.actionDispatcher.dispatch(new DistantSaleAction('distant_sales_form','creditCard'));
  }

  public onPreInfo() {
    this.actionDispatcher.dispatch(new PreInfoSaleAction('pre_info_contract'));
  }

  public onNext() {
    if (!this.preInfoAggreement) {
      this.$translate('pay.preInfo.error').then(value => {
        this.notificationService.showNotification({
          text: value,
          type: 'warning'
        });
      });
      return;
    }

    if (!this.distantAggreement) {
      this.$translate('pay.distant.error').then(value => {
        this.notificationService.showNotification({
          text: value,
          type: 'warning'
        });
      });
      return;
    }

    if (this.activeCard.showEulaId) {
      this.actionDispatcher.dispatch(
        new OpenCardAddContractAction(() => this.onAcceptContract())
      );
      return;
    } else {
      this.actionDispatcher.dispatch(
        new PayByPaycellAction(this.activeCard.paymentMethodID, this.activeCard.cardId)
      );
    }
  }

  private onAcceptContract() {
    this.globalSpinner.start();
    this.paycellService
      .updatePaymentMethod(this.activeCard.paymentMethodID, null, this.activeCard.cardId)
      .then(() =>
        this.actionDispatcher.dispatch(
          new PayByPaycellAction(this.activeCard.paymentMethodID, this.activeCard.cardId)
        )
      )
      .finally(() => this.globalSpinner.stop());
  }

  private comparator(element: any): boolean {
    return element.isDefault == true;
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/pay-by-card/pay-by-card.controller.ts